import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface AuthLayoutProps {
  children: React.ReactNode;
  title: string;
  description: string;
}

export default function AuthLayout({ children, title, description }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <div className={cn(
        "flex-1 flex flex-col items-center justify-center p-4 pb-[env(safe-area-inset-bottom,0px)]",
        "bg-muted/30 pt-[calc(64px+env(safe-area-inset-top,0px))]"
      )}>
        <div className="w-full max-w-md">
          <Card>
            <CardHeader>
              <CardTitle>{title}</CardTitle>
              <CardDescription>{description}</CardDescription>
            </CardHeader>
            <CardContent>
              {children}
            </CardContent>
          </Card>
          
          <div className="mt-4 text-center text-sm text-muted-foreground">
            <Link to="/" className="underline hover:text-foreground">
              Return to homepage
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
